module.exports = __webpack_public_path__ + "img/carousel-2.43b0c5df.png";